import React, { Component } from 'react';
import NormalLink from './NormalLink';
import DropDown from './DropDown';
import { Link } from 'react-router-dom';
import { withRoute } from '../../util/withRoute';
import './sidebar.css';

const package_json = require('.././../../package.json');

class Sidebar extends Component {
  constructor() {
    super();
    this.state = {};
  }

  getAvatarInitials = () => {
    const { partneraccount, user } = this.props;
    const name = partneraccount?.contact_name || partneraccount?.first_name || (user && user.data && user.data.username) || '';
    if (!name) return 'VM';
    return name.trim().split(/\s+/).filter(Boolean).map(w => w[0]).join('').toUpperCase().slice(0, 2) || 'VM';
  };

  handleGenerateLinksForOneVenue = (activeVenueId) => {
    let newLinks = [
      {
        isNormalLink: true,
        isUrlArray: false,
        url: `/dashboard`,
        name: 'Dashboard',
        icon: 'ti ti-layout-dashboard',
        shouldHavePermissions: [],
      },
      {
        isNormalLink: true,
        isUrlArray: false,
        url: `/lead/list`,
        name: 'Leads',
        icon: 'ti ti-users',
        shouldHavePermissions: ['leads:read'],
      },
      {
        isNormalLink: true,
        isUrlArray: false,
        url: `/booking/list`,
        name: 'Bookings',
        icon: 'ti ti-file-text',
        shouldHavePermissions: ['booking:read'],
      },
      {
        isNormalLink: true,
        isUrlArray: false,
        url: `/member/list`,
        name: 'Members',
        icon: 'ti ti-user-circle',
        shouldHavePermissions: ['member:read'],
      },
      {
        isDivider: true,
        label: 'Tools',
      },
      {
        isNormalLink: true,
        isUrlArray: false,
        url: `/${this.props.activeVenue._id}/calendar`,
        name: 'Calendar',
        icon: 'ti ti-calendar',
        shouldHavePermissions: ['member:read'],
      },
      {
        isNormalLink: true,
        isUrlArray: false,
        url: `/visit/lead/list`,
        name: 'Visit Leads',
        icon: 'ti ti-map-pin',
        shouldHavePermissions: ['leads:read'],
      },
      {
        isNormalLink: true,
        isUrlArray: false,
        url: `/${this.props.activeVenue._id}/venue-updator`,
        name: 'VenueUpdator',
        icon: 'ti ti-building',
        shouldHavePermissions: ['member:read'],
      },
    ];

    newLinks = newLinks.filter((item) => {
      if (item.isDivider) return true;
      let isShow = true;
      if (
        this.props.userPermissions &&
        this.props.userPermissions.length > 0 &&
        item.shouldHavePermissions &&
        item.shouldHavePermissions.length > 0
      ) {
        let matchParam = item.shouldHavePermissions.filter(
          (p) => this.props.userPermissions.indexOf(p) !== -1
        );
        isShow = matchParam && matchParam.length > 0;
      }
      return isShow;
    });

    return newLinks;
  };

  render() {
    const { isShowSideBar, toggleSideBar, handleLogOut, user, location, partneraccount } = this.props;
    const username = user && user.data && user.data.username ? user.data.username : 'VenueMonk';
    const newLinks = this.handleGenerateLinksForOneVenue(this.props.activeVenueId);

    const getFullName = () => {
      if (partneraccount?.contact_name) return partneraccount.contact_name;
      if (partneraccount?.first_name && partneraccount?.last_name)
        return `${partneraccount.first_name} ${partneraccount.last_name}`;
      return username;
    };

    const getRole = () => {
      const role = partneraccount?.role || 'admin';
      if (role.toLowerCase() === 'admin') return 'Administrator';
      return role.charAt(0).toUpperCase() + role.slice(1);
    };

    return (
      <div className={`vm-sidebar ${isShowSideBar ? '' : 'collapsed'}`}>

        {/* Header */}
        <div className="vm-sidebar-header">
          {isShowSideBar && (

          <div className="vm-brand">
            <div className="vm-brand-logo">VM</div>
            <span className="vm-brand-name">VenueMonk</span>
          </div>
          )}
          <button className="vm-collapse-btn" onClick={() => toggleSideBar()}>
            <i className={`ti ${isShowSideBar ? 'ti-chevron-left' : 'ti-chevron-right'}`} />
          </button>
        </div>

        {/* Nav */}
        <div className="vm-nav-body">
          <div className="vm-nav-label">Menu</div>

          {newLinks.map((item, index) => {
            if (item.isDivider) {
              return (
                <div key={`divider-${index}`}>
                  <div className="vm-nav-divider" />
                  <div className="vm-nav-label">{item.label}</div>
                </div>
              );
            }

            if (item.isNormalLink) {
              return (
                <NormalLink
                  key={item.url}
                  url={item.url}
                  name={item.name}
                  icon={item.icon}
                  isUrlArray={item.isUrlArray}
                  isShowSideBar={isShowSideBar}
                  pathName={location.pathname || ''}
                  toggleSideBar={toggleSideBar}
                />
              );
            }

            return (
              <DropDown
                key={item.name}
                name={item.name}
                list={item.list}
                activeUrl={this.props.activeUrl}
                isShowSideBar={isShowSideBar}
                toggleSideBar={toggleSideBar}
              />
            );
          })}
        </div>

        {isShowSideBar && (
          <div className="vm-sidebar-extra">
            <div className="vm-sidebar-version">Version {package_json.version}</div>
            <Link to="/" onClick={() => handleLogOut()} style={{ textDecoration: 'none', width: '100%' }}>
              <button className="vm-sidebar-logout-container-btn">
                <i className="ti ti-power" />
                <span>Logout</span>
              </button>
            </Link>
          </div>
        )}

        {/* Footer */}
        <div className="vm-sidebar-footer">
          <div className="vm-user-row">
          {isShowSideBar && (
            <>
            <div className="vm-avatar">{this.getAvatarInitials()}</div>
            <div className="vm-user-info">
              <div className="vm-user-name">{getFullName()}</div>
              <div className="vm-user-role">{getRole()}</div>
            
            </div>
            </> )}
            <Link to="/" onClick={() => handleLogOut()}>
              <button className="vm-logout-btn" title="Logout">
                <i className="ti ti-dots" />
              </button>
            </Link>
          </div>
        </div>

      </div>
    );
  }
}

export default withRoute(Sidebar);
